<template>
  <div class="flex flex-col items-center w-full space-y-10 pb-5">
    <user-review class="w-full !border-b-0" :review="review" />
  </div>
</template>

<script setup lang="ts">
import UserReview from "@/components/UserReview.vue";
import {PropType} from "vue";
import {ReviewInterface} from "@/interfaces/ReviewInterface";

defineProps({
  review: {
    type: Object as PropType<ReviewInterface>,
    required: true
  }
})

</script>